export default function markdown(str) {
    let bold = /(^|[^\\])\*((?:.*?[^\\])?)\*/gm;
    let mark = /(^|[^\\])#((?:.*?[^\\])?)#/gm;
    let italics = /(^_|[^\\]_)(.*?[^\\])_/gm;
    let strike = /(^~|[^\\]~)(.*?[^\\])~/gm;


    str = str.replace(/</g, '&lt;');
    str = str.replace(/>/g, '&gt;');

    str = str.replace(bold, '$1<strong>$2</strong> ');
    str = str.replace(italics, '$1<em>$2</em> ');
    str = str.replace(strike, '$1<s>$2</s> ');
    str = str.replace(mark, "$1<mark>$2</mark>");

    // handle escaped chars
    str = str.replace(/\\\*/gm, "*");
    str = str.replace(/\\_/gm, "_");
    str = str.replace(/\\#/gm, "#");


    return str;
}